module.exports = __webpack_public_path__ + "static/media/count50Off_118.171a9753.png";